import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledIcon = styled.svg.withConfig({
  displayName: "LanguageIcon__StyledIcon"
})(({
  theme
}) => ({
  fill: theme.color['icon-core-subtle'],
  inlineSize: theme.space[500],
  blockSize: theme.space[500]
}));
const LanguageIcon = () => {
  return /*#__PURE__*/_jsxs(StyledIcon, {
    "data-test-id": "language-icon",
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.86 31.86c-8.83 0-16-7.18-16-16s7.17-16 16-16 16 7.18 16 16-7.18 16-16 16m0-29.72C8.3 2.14 2.15 8.29 2.15 15.85S8.3 29.56 15.86 29.56s13.71-6.15 13.71-13.71S23.42 2.14 15.86 2.14"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.86 12.43c-4.77 0-9.54-.97-13.43-2.9-.56-.28-.8-.97-.51-1.53.28-.56.97-.79 1.53-.51 7.19 3.57 17.63 3.57 24.82 0 .57-.28 1.25-.05 1.53.52s.05 1.25-.52 1.53c-3.89 1.93-8.66 2.9-13.42 2.9ZM28.77 24.35q-.255 0-.51-.12c-7.19-3.57-17.62-3.57-24.81 0-.57.28-1.25.05-1.53-.52s-.05-1.25.52-1.53c7.78-3.86 19.07-3.86 26.84 0a1.146 1.146 0 0 1-.5 2.17Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.86 31.86c-4.45 0-6.86-8.24-6.86-16s2.4-16 6.86-16 6.86 8.24 6.86 16-2.4 16-6.86 16m0-29.72c-1.91 0-4.57 5.22-4.57 13.71s2.66 13.71 4.57 13.71 4.57-5.22 4.57-13.71-2.66-13.71-4.57-13.71"
    })]
  });
};
export default LanguageIcon;